(function( $ ) {
    mybutton = document.getElementById("myBtn");

    // When the user scrolls down 20px from the top of the document, show the button
    if ($(window).width() >= 993) {
        window.onscroll = function () {
            scrollFunction()
        };
    }

    function scrollFunction() {
        if (document.body.scrollTop > 60 || document.documentElement.scrollTop > 60) {
            mybutton.style.display = "block";
        } else {
            mybutton.style.display = "none";
        }
    }


    $(".js-back-to-top").click(function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
    });

}( jQuery ));